import {AGGREGATION_TYPES, AggregationType} from 'features/admin/lib/metrics';

import React from 'react';
import cn from 'classnames';


import styles from './AggregationSelector.module.scss';

interface AggregationSelectorProps {
    value: AggregationType;
    // eslint-disable-next-line no-unused-vars
    onChange: (value: AggregationType) => void;
}

const AggregationSelector: React.FC<AggregationSelectorProps> = ({ value, onChange }) => {
    return (
        <div className={styles.container}>
            <span className={styles.title}>Детализация:</span>
            <div className={styles.buttons}>
                {AGGREGATION_TYPES.map(type => (
                    <button
                        key={type.id}
                        onClick={() => onChange(type.id)}
                        className={cn(
                            styles.button,
                            value === type.id && styles.active,
                        )}
                    >
                        {type.label}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default AggregationSelector;